<div class="resources resources-{{cid}}"></div>